export class JwtResponse {
  token: string;
  type: string;
  account: string;
  name: string;
  role: string;
  fbtoken: string;
}
